const LEFT_TO_RIGHT_ISOLATE = String.fromCodePoint(0x2066);
const POP_DIRECTIONAL_ISOLATE = String.fromCodePoint(0x2069);
/* Keeps "404" and the name on one line, so a narrow column never strands the number. */
const NO_BREAK_SPACE = String.fromCodePoint(0xa0);
/* "404 Estate" and "404 Creative", also when someone typed them reversed. */
const BRAND = /\b404\s+(Estate|Creative)\b|\b(Estate|Creative)\s+404\b/g;

/** Keep the brand reading left to right, never "Estate 404", even inside Arabic text. */
export function lockBrand(text: string): string {
  return text.replace(BRAND, (_match, name: string | undefined, reversed: string | undefined) => {
    const product = name ?? reversed ?? "Estate";
    return `${LEFT_TO_RIGHT_ISOLATE}404${NO_BREAK_SPACE}${product}${POP_DIRECTIONAL_ISOLATE}`;
  });
}
